import styled from "styled-components";
import { Spinner } from "react-bootstrap";
import React, { useCallback, useState, useEffect } from "react";
import { CustomCard } from "../common-styling";
import { fetchBlockedPostalCodesCount } from "../../services/api-declaration";
import { useTranslation } from "react-i18next";

const Customcard = styled(CustomCard)`
  margin-top: 4px;
  &:hover {
    background: #dff0ff;
  }
`;
const BlockedPostalCodeCount = ({ funnelId, toggleDrawer }) => {
  const [blockedPostalCodeCount, setblockedPostalCodeCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslation();

  const getBlockedPostalCodesCount = async (funnelId) => {
    try {
      const response = await fetchBlockedPostalCodesCount(funnelId);
      setblockedPostalCodeCount(response.data?.data?.count);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  const getBlockedPostalCodesCountCb = useCallback(
    (funnelId) => getBlockedPostalCodesCount(funnelId),
    []
  );
  useEffect(() => {
    getBlockedPostalCodesCountCb(funnelId);
  }, [getBlockedPostalCodesCountCb, funnelId]);

  return (
    <Customcard>
      <div
        onClick={() => blockedPostalCodeCount && toggleDrawer()}
        className="p-2 fw-bold cursor-pointer d-flex flex-row"
      >
        <span className="text-secondary"> {t("common.blockedPostalCode")}</span>
        <span className="text-danger cursor-pointer ms-1">
          {isLoading ? (
            <Spinner size="sm" animation="border" className="ms-1" />
          ) : (
            blockedPostalCodeCount
          )}
        </span>
      </div>
    </Customcard>
  );
};
export default BlockedPostalCodeCount;
